/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';

export default class ContentBundleSaveService extends BaseService {
  constructor() {
    super(constants.CONTENT_BUNDLE_SAVE, 'contentBundleSaveStatus');
  }

  handleEvent(eventName, event) {
    if (event.payload && event.payload.length > 0) {
      return this.getClient('evergreen').post('/contentbundle', event.payload);
    }
    return null;
  }

  handleResponse(response, event) {
    // eslint-disable-line class-methods-use-this
    const store = Framework.getStoreRegistry().getStore('contentBundleState');
    store.setSaveStatus('success');
    if (event && event.payload && event.payload.length > 0 && event.payload[0].bookId) {
      store.fetchBundles(event.payload[0].bookId);
    }
    store.setLastUpdated();
    const notification = {
      open: true,
      message: 'Content Bundle saved successfully!',
      type: 'info'
    };
    Framework.getStoreRegistry().getStore('notificationState').set(notification);
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    Framework.getStoreRegistry().getStore('contentBundleState').setSaveStatus('error');
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if ((status === 500 || status === 400) && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message ? data.error.message : data.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    }
  }

  mapPayload(payload) {
    // eslint-disable-line class-methods-use-this
    return {
      globalBookId: payload.globalBookId,
      bookId: payload.bookId,
      bundleLabel: payload.bundleLabel,
      bundleUri: Array.isArray(payload.bundleUri) ? payload.bundleUri : [],
      createdBy: payload.createdBy,
      bundleId: payload.bundleId || null
    };
  }
}
